type stringMapper = (x: string) => string;

export const DottedKeyToFlatKey: stringMapper = (value: string): string => {
    if (value.indexOf('.') === -1) {
        return value;
    }
    const [family, ...rest] = value.split('.');
    return rest.join('');
};
